<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav7_blue.svg" alt="">法人一覧</h1>
      <div class="l-btn-createnew_pos">
        <div class="btn-cop-upload" v-show="isAdmin" @click="goCsv('')"><a>CSVでアップロード（一括新規作成）</a></div>
        <div class="btn-create-new_wh" @click="goInput('')" :disabled="isProcessing"><a>法人の新規作成</a></div>
      </div>
      <div class="l-contentsBox">
        <div class="l-contentsSection">
          <div class="company-modal__search"  style="padding-left:0;margin-bottom: 20px;border-bottom:none;">
            <div class="l-inputBlock">
              <div v-if="!(!isSystemAdmin && !isAllPermission)" class="l-inputAccount w-vshort">
                <TextBox v-model="searchForm.corpNum" placeholder="管理法人番号" name="searchCorpNum" ></TextBox>
              </div>
              <div class="l-inputAccount w-vshort">
                <TextBox v-model="searchForm.subordinateNum" placeholder="顧問先番号" name="searchSubordinateNum" ></TextBox>
              </div>
              <div class="l-inputAccount w-short">
                <TextBox v-model="searchForm.corpName" placeholder="法人名" name="searchCorpNm" ></TextBox>
              </div>
              <div>
                <label class="l-checkbox" :class="{ 'is-selected' : searchForm.isOnlyResponsible }">
                  <input type="checkbox" v-model="searchForm.isOnlyResponsible"> 表示設定した法人のみ
                </label>
              </div>
              <div>
                <div class="btn-basic is-inlne is-primary" @click="getFilteredCorporateList()" :disabled="isProcessing"><a>絞り込み</a></div>
              </div>
            </div>
          </div>
          <table class="table-base audit-table  table-select">
            <colgroup>
              <col v-if="isSystemAdmin || isAllPermission" style="width: 140px;">
              <col v-if="isSystemAdmin || isAllPermission" style="width: 140px;">
              <col style="width: 140px;">
              <col style="width: 300px;">
              <col style="width: 160px;">
              <col>
            </colgroup>
            <thead>
              <tr class="is-sort">
                <th v-if="isSystemAdmin || isAllPermission"
                  :class="getSortClass(searchForm.sortKey.isSortedByCorpAuth)"
                  @click="sortByCorpAuth()"><span>法人権限</span></th>
                <th v-if="isSystemAdmin || isAllPermission"
                  :class="getSortClass(searchForm.sortKey.isSortedByManageCorpNum)"
                  @click="sortByManageCorpNum()"><span>管理法人番号</span></th>
                <th class="t-left"
                  :class="getSortClass(searchForm.sortKey.isSortedBySubordinateNum)"
                  @click="sortBySubordinateNum()"><span>顧問先番号</span></th>
                <th class="t-left"
                  :class="getSortClass(searchForm.sortKey.isSortedByCorpNameKana)"
                  @click="sortByCorpNameKana()"><span>法人名</span></th>
                <th v-if="!isSystemAdmin && !isAllPermission"
                  class="t-left"
                  :class="getSortClass(searchForm.sortKey.isSortedByResponsibleName)"
                  @click="sortByResponsibleName()"><span>担当</span></th>
                <th v-else
                  class="t-left"
                  :class="getSortClass(searchForm.sortKey.isSortedByManageCorpName)"
                  @click="sortByManageCorpName()"><span>親ユーザー</span></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="corporate in corporateList" :key="corporate.corpId" @click="goEdit(corporate.corpId)">
                <!-- 法人権限 -->
                <td v-if="isSystemAdmin || isAllPermission">{{ corporate.corpAuthority.corpAuthNm }}</td>
                <!-- 管理法人番号 -->
                <td v-if="(isSystemAdmin || isAllPermission) && corporate.manageCorporate">
                  <template v-if="corporate.corpAuthNo == 9">{{ corporate.manageCorporate.corpNumber }}</template>
                  <template v-else-if="corporate.corpAuthNo == 3">{{ ((""+corporate.corpId).length)>3?corporate.corpId:('00' + corporate.corpId).slice(-3) }}</template>
                  <template v-else><!-- 何も表示しない --></template>
                </td>
                <!-- 顧問先番号 -->
                <td>{{ corporate.corpAuthNo == 9 ? corporate.subordinateNum : '' }}</td>
                <!-- 法人名 -->
                <td>{{ corporate.corpNm }}</td>
                <!-- 担当 -->
                <td v-if="!isSystemAdmin && !isAllPermission">
                  {{ corporate.responsibleName }}
                </td>
                <!-- 親ユーザー -->
                <td v-else>
                  {{ corporate.manageCorporate && corporate.corpAuthNo == '9' ? corporate.manageCorporate.corpNm : '' }}
                </td>
                <td style="text-align:right;">
                  <div class="btn-delete js-btn-delete" data-text="" v-if="corporate.isDeletable">
                    <a @click.stop="deleteCorporate(corporate.corpId)">削除</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import TextBox from '@/components/parts/form/TextBox.vue';

export default {
  name: 'CorporateList',
  components: {
    Loading,
    Pagination,
    TextBox,
  },
  data() {
    return {
      pageInfo: {},
      corporateList: [],
      searchForm: {
        corpNum: null,
        subordinateNum: null, // 顧問先番号
        corpName: null,
        isOnlyResponsible: false,
        sortKey: {
          isDefaultSort: true,
          isAscendingSort: true,
          isSortedByCorpAuth: false,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
          isSortedByManageCorpName: false,
        },
      },
      isProcessing: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isAdmin: false
    }
  },
  created: async function(){
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    await this.getCorporateList(1);
    this.isProcessing = false;
  },
  methods: {
    async emitChangePage(page) {
      this.isProcessing = true;
      await this.getCorporateList(page)
      this.isProcessing = false;
    },
    async getCorporateList(page) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateList', {
        page: page,
        sortKey: this.searchForm.sortKey,
      });
      if (res) {
        this.corporateList = res.data.corporateList.data;
        this.pageInfo = {
          currentPage: res.data.corporateList.current_page,
          lastPage: res.data.corporateList.last_page,
          total: res.data.corporateList.total,
          from: res.data.corporateList.from,
          to: res.data.corporateList.to,
        };
      }
    },
    async getFilteredCorporateList() {
      let res = await this.$axios.post('/ld/api/corporate/getFilteredCorporateList', {
        page: 1,
        corpNum: this.searchForm.corpNum,
        subordinateNum: this.searchForm.subordinateNum,
        corpNm: this.searchForm.corpName,
        isOnlyResponsible: this.searchForm.isOnlyResponsible,
        sortKey: this.searchForm.sortKey,
      });
      if (res) {
        this.corporateList = res.data.corporateList.data;
        this.pageInfo = {
          currentPage: res.data.corporateList.current_page,
          lastPage: res.data.corporateList.last_page,
          total: res.data.corporateList.total,
          from: res.data.corporateList.from,
          to: res.data.corporateList.to,
        };
      }
    },
    goEdit(corpId) {
      this.$store.dispatch('user/setCorpId', corpId);
      this.$router.push({ name: 'corporate-edit', query: { corpId: corpId } });
    },
    goInput() {
      this.$store.dispatch('user/setCorpId', null);
      this.$router.push({ name: 'corporate-new' });
    },
    goCsv() {
      this.$router.push({ name: 'corporate-csv', params: {} });
    },
    getSortClass(sortFlag) {
      let classStr = ''
      if (sortFlag) classStr += 'is-sorted ';
      if (sortFlag && this.searchForm.sortKey.isAscendingSort) classStr += 'is-ascending';
      if (sortFlag && !this.searchForm.sortKey.isAscendingSort) classStr += 'is-descending';
      return classStr;
    },

    isFiltering(searchForm) {
      return searchForm.corpNum != null
          || searchForm.subordinateNum != null
          || searchForm.corpName != null
          || searchForm.isOnlyResponsible == true
    },
    async sortByCorpAuth() {
      if (this.searchForm.sortKey.isSortedByCorpAuth) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByCorpAuth: true,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
          isSortedByManageCorpName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateList();
      } else {
        await this.getCorporateList(1);
      }
    },
    async sortByManageCorpNum() {
      if (this.searchForm.sortKey.isSortedByManageCorpNum) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByCorpAuth: false,
          isSortedByManageCorpNum: true,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
          isSortedByManageCorpName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateList();
      } else {
        await this.getCorporateList(1);
      }
    },
    async sortBySubordinateNum() {
      if (this.searchForm.sortKey.isSortedBySubordinateNum) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByCorpAuth: false,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: true,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
          isSortedByManageCorpName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateList();
      } else {
        await this.getCorporateList(1);
      }
    },
    async sortByCorpNameKana() {
      if (this.searchForm.sortKey.isSortedByCorpNameKana) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByCorpAuth: false,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: true,
          isSortedByResponsibleName: false,
          isSortedByManageCorpName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateList();
      } else {
        await this.getCorporateList(1);
      }
    },
    async sortByResponsibleName() {
      if (this.searchForm.sortKey.isSortedByResponsibleName) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByCorpAuth: false,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: true,
          isSortedByManageCorpName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateList();
      } else {
        await this.getCorporateList(1);
      }
    },
    async sortByManageCorpName() {
      if (this.searchForm.sortKey.isSortedByManageCorpName) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByCorpAuth: false,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
          isSortedByManageCorpName: true,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateList();
      } else {
        await this.getCorporateList(1);
      }
    },

    async deleteCorporate(corpId) {
      const ans = confirm('削除しますか？');
      if (ans) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/corporate/delete', {
          corpId: corpId,
        });
        if (res) {
          this.$toast.info('削除しました');
          await this.getCorporateList(1);
        } else {
          this.$toast.error('エラーが発生しました。');
        }
        this.isProcessing = false;
      }
    },
  }
}
</script>
